import { render, staticRenderFns } from "./AS_TariffOrder.vue?vue&type=template&id=f48f60de&scoped=true&"
import script from "./AS_TariffOrder.vue?vue&type=script&lang=js&"
export * from "./AS_TariffOrder.vue?vue&type=script&lang=js&"
import style0 from "./AS_TariffOrder.vue?vue&type=style&index=0&id=f48f60de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48f60de",
  null
  
)

export default component.exports